import type { Transition, TargetAndTransition } from 'framer-motion';

// ----------------------------------------------------------------------

export const varHover = (value: number = 1.09): TargetAndTransition => ({
  scale: value,
});

export const varTap = (value: number = 0.9): TargetAndTransition => ({
  scale: value,
});

export const transitionTap = (props?: Transition): Transition => ({
  type: 'spring',
  stiffness: 400,
  damping: 18,
  ...props,
});

export const transitionHover = (props?: Transition): Transition => ({
  duration: 0.32,
  ease: [0.43, 0.13, 0.23, 0.96],
  ...props,
});
